module.exports = __webpack_public_path__ + "static/media/story-7.d333ea34.jpg";